import { useQuery } from '@tanstack/react-query';
import { getTaskTypes } from 'api/taskTypes';
import { taskTypesKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useTaskTypesQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: taskTypesKeys.list(companyId),
    queryFn: () => getTaskTypes().then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
